import { JobDto, JobExtendedModel, mapJobDtoToExtendedModel } from 'api/dto/JobExtended.dto';
import { JobName } from 'model/JobName';

export type JobModel = {
  job: JobExtendedModel;
  projectId: number;
};

export function mapJobDtoToModel(dto: JobDto, projectId?: number): JobModel {
  return {
    job: dto ? mapJobDtoToExtendedModel(dto) : undefined,
    projectId: projectId,
  };
}

export namespace JobModel {
  export function isProcessEmployeeDatabaseJob(job: JobModel): boolean {
    return job && job.job.name === JobName.ProcessEmployeeDatabase;
  }

  export function isCommitEmployeeDatabaseJob(job: JobModel): boolean {
    return job && job.job.name === JobName.CommitEmployeeDatabase;
  }

  export function isCreateContactListJob(job: JobExtendedModel): boolean {
    return job && job.name === JobName.CreateContactList;
  }

  export function isUploadUsersJob(job: JobModel): boolean {
    return job && job.job.name === JobName.UploadUsers;
  }

  export function isReleasePulseProjectJob(job: JobModel): boolean {
    return job && job.job.name === JobName.ReleasePulseProject;
  }

  export function isPublishProjectSubmits(job: JobModel): boolean {
    return job && job.job.name === JobName.PublishProjectSubmits;
  }

  export function isUpdateEmailStatusesJob(job: JobExtendedModel): boolean {
    return job && job.name === JobName.UpdateEmailStatuses;
  }

  export function isProcessLifecycleRespondents(job: JobModel): boolean {
    return job?.job.name === JobName.ProcessLifecycleRespondents;
  }

  export function sortByExecutionTime(a: JobModel, b: JobModel): number {
    return b.job.executionTime - a.job.executionTime;
  }
}
